import { render, staticRenderFns } from "./cancelTips.vue?vue&type=template&id=ef5f362e"
import script from "./cancelTips.vue?vue&type=script&lang=js"
export * from "./cancelTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports